// extracted by mini-css-extract-plugin
export default {"paymentSection":"A--z","disabled":"B--z"};